import React from "react";

import { cn } from "../../../common/u1/cn";
import { ArrowRight, StatusGlyph, ClockIcon } from "../../../../assets/ui/icons";
import { OWNER_CTA_LABEL, ownerCtaDisabled } from "./ownerCta";

/* What the company's own people see where everyone else sees "Buy a Web Profile". */
const STATUS_KINDS = ["verified", "in-progress", "modified", "requested"];

export const ProfileOwnerCta = ({ kind, role, submitting, onGetVerified, onGetMembership }) => {
  if (!kind) return null;

  const label = OWNER_CTA_LABEL[kind];
  const disabled = ownerCtaDisabled(role);

  if (kind === "verified") {
    return (
      <span
        className={cn(
          "inline-flex h-11 items-center justify-center gap-2 rounded-[10px]",
          "border border-[var(--verified-border)] bg-[var(--success-soft)]",
          "text-[14px] font-semibold text-[var(--success)] font-sans"
        )}
      >
        <StatusGlyph kind="verified" size={14} />
        {label}
      </span>
    );
  }

  if (STATUS_KINDS.includes(kind)) {
    return (
      <span
        role="status"
        className={cn(
          "inline-flex min-h-11 items-center justify-center gap-2 rounded-[10px]",
          "border border-[var(--line)] bg-white px-3 py-2 text-center",
          "text-[13px] font-semibold text-[var(--ink-2)] font-sans"
        )}
      >
        <ClockIcon size={14} />
        {label}
      </span>
    );
  }

  const onClick = kind === "get-verified" ? onGetVerified : onGetMembership;

  return (
    <button
      type="button"
      disabled={disabled || submitting}
      onClick={onClick}
      className={cn(
        /* Sized to its label: it sits on the More row now, not stacked in a
           card, so a full-width button would span the masthead. */
        "inline-flex h-11 items-center justify-center gap-1.5 rounded-[10px] px-5",
        "bg-[var(--coral)] text-[14px] font-semibold text-white font-sans",
        "shadow-[shadow:var(--coral-glow)] transition-colors",
        "hover:bg-[var(--orange-hover)] focus-visible:outline-none",
        "focus-visible:ring-2 focus-visible:ring-[var(--coral)] focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50"
      )}
    >
      {submitting && kind === "get-verified" ? "Requesting…" : label}
      <ArrowRight size={15} />
    </button>
  );
};

export default ProfileOwnerCta;
